class GateData {
	constructor () {
		this.STORAGE_KEY = 'gateFormData';
		this.ITBL_RETURN_USER_EMAIL_KEY = "iterable/encrypted/Email";
		this.ITBL_BOBA = window.atob("VEhBSV9URUFfV19CT0JBX01FRElVTV9TV0VFVA==");
	}

	set (data) {
		window.localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
	}

	getActivate () {
		const raw = window.localStorage.getItem(this.STORAGE_KEY);
		return raw ? JSON.parse(raw) : null;
	}

	getIterable () {
		const getField = localStorageKey => {
			const encryptedValueRaw = window.localStorage.getItem(localStorageKey);
			const encryptedValue = JSON.parse(encryptedValueRaw);

			if (!encryptedValue) {
				return "false";
			}

			const value = window.sjcl.decrypt(this.ITBL_BOBA, encryptedValue);

			return value;
		};

		const data = {
			Company: getField("iterable/encrypted/Company"),
			Country: getField("iterable/encrypted/Country"),
			Email: getField("iterable/encrypted/Email"),
			FirstName: getField("iterable/encrypted/FirstName"),
			LastName: getField("iterable/encrypted/LastName"),
			marketingConsent: getField("iterable/encrypted/marketingConsent"),
		};

		return data;
	}

	get () {
		if (!this.isSet()) {
			return null;
		}

		return this.getActivate() || this.getIterable();
	}

	isSetOnIterable () {
		return !!window.localStorage.getItem(this.ITBL_RETURN_USER_EMAIL_KEY);
	}

	isSetOnActivate () {
		return !!window.localStorage.getItem(this.STORAGE_KEY);
	}

	isSet () {
		return this.isSetOnIterable() || this.isSetOnActivate();
	}
}
